@if (!isAdminScheduler()) {
	<div class="calendar-header">
		<md-header>Share Additional Availability</md-header>
		<button md-button class="clear-button" (click)="clearSelection()">Clear all</button>
	</div>

	<lb-announcement-banner type="info">
		Please provide us with as many additional hours during the week when the learner is available for lessons. This time will be used for scheduling if the
		preferred lesson time does not match to an instructor.
		<br />
		<br />
		Select the additional lesson time by clicking and dragging on the calendar below. The blue blocked time denotes the previously entered preferred time.
	</lb-announcement-banner>
}

<lb-schedule-base-calendar
	[class.selected]="selectedSchedules().length > 0"
	[formStep]="formStep"
	[selectedSchedules]="selectedSchedules()"
	[preferredTimeSlots]="preferredTimeSlots()"
	(removeScheduleSelection)="removeScheduleSelection($event)"
	(addScheduleSelection)="addScheduleSelection($event)"
>
</lb-schedule-base-calendar>
